import { PickupParticipantEditPage } from "components/shared/pickupParticipants";
import { PickupInformationSection } from "../../components/DetailForm/PickupInformation";
import { EditInformationSection as InformationSection } from "../../components/form/InformationSection";
import { EditRegistrationInformationSection as RegistrationInformationSection } from "../../components/form/RegistrationSection";

const WPSCheckinAttractionParticipantsEditPage = () => (
  <PickupParticipantEditPage
    kind="attraction"
    variant="wps"
    sections={{
      InformationSection,
      RegistrationInformationSection,
      PickupInformationSection,
    }}
  />
);

export default WPSCheckinAttractionParticipantsEditPage;
